<template>
    <div class="a-flex-rfsfs">
        <div class="s-search-label a-flex-rfsc a-mt-8" :style="{ 'width': labelwidth }" v-show="label">
            <span class="a-c-red a-fs-14" v-if="notnull">*</span>
            <div>{{  label  }}</div>
        </div>
        <div v-if="!readonly">
            <el-upload :show-file-list="false" :action="url" :headers="headers" :data="data" :on-preview="handlePreview"
                :on-remove="handleRemove" :before-remove="beforeRemove" :limit="limit" :on-exceed="handleExceed"
                :on-success="handleSuccess" :file-list="fileList" name="file" :on-change="handleChange"
                :accept="acceptVali" ref="upload">
                <el-button style="border: 1px solid #DADDE0;border-radius: 4px;" icon="el-icon-upload2" >上传文件</el-button>
                <slot name="tip"></slot>
            </el-upload>
            <div class="a-mt-16 a-flex-rfsc" v-if="fileList.length">
                <div class="img-content" v-for="(item, index) in fileList" :key="index">
                    <img :src="item.url" style="width:100px;height:100px;border-radius: 4px;" alt="" @click="handlePreview(index, fileList)">
                    <i class="el-icon-error deleteImg" @click="beforeRemove(item, index)" ></i>
                </div>
            </div>
            <div class="el-upload__tip a-c-999 a-fs-14">
				支持：{{ acceptStr }}格式
			</div>
        </div>
        <div class="a-flex-rfsc" v-else>
            <div class="img-content" v-for="(item, index) in fileList" :key="index">
                <img :src="item.url" style="width:100px;height:100px;border-radius: 4px;" alt="" @click="handlePreview(index, fileList)">
            </div>
        </div>
        <le-preview-img v-model="showPreviewImg" :imgList="previewList" :showIndex="showIndex"></le-preview-img>
    </div>
</template>

<script>
import Utils from '@/utils';
export default {
    props: {
        labelwidth: {
            type: String
        },
        label: {
            type: String,
        },
        value: {
            required: false,
            default: "",
        },
        notnull: {
            type: Boolean,
            default: false,
            required: false,
        },
        /**
         * 是否为较长的输入框
         */
        large: {
            type: Boolean,
            required: false,
            default: false,
        },
        acceptArr: {
            type: Array,
            default: () => [".png", ".jpg", ".jpeg"],
        },
        limit: {
            type: Number,
            default: 1,
        },
        uploadUrl: {
            type: String,
            default: ''
        },
        imgList: {
            type: Array,
            default: ()=> []
        },
        mediaList: {
            type: Array,
            default: ()=> []
        },
        readonly: {
            type: Boolean,
            default: false
        },
        uploadWxType: {
            default: '',//上传图片至微信的type
        },
        extraParams: {
            default: ()=>{
                return {}
            }
        }
    },
    computed: {
        acceptStr() {
            return this.acceptArr.join("，");
        },
        acceptVali() {
            return this.acceptArr.join(",");
        },
    },
    watch: {
        uploadUrl: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.url = this.$Config.axiosBaseUrl + val
                }
            }
        }
    },
    mounted() {
        setTimeout(()=>{
            if(this.imgList && this.imgList.length){
                this.fileList =this.imgList.map((item,index)=>{
                    return {
                        name: item,
                        url: item,
                        mediaId: this.mediaList[index] || ''
                    }
                })
            }
        },500)
        // this.fileList.push({"name":"aaa.pj"});
        // this.$emit('input', this.fileList)
        // console.log("le-upload-file-img.vue：",this.value);
    },
    data() {
        return {
            url: this.$Config.axiosBaseUrl + this.$Config.apiUrl.uploadFile,
            headers: {
                token: Utils.getToken(),
                appId: this.$Config.appId,
            },
            data: {
                key: "company/upload",
            },
            fileList: [],
            filesImg: {},
            iswatch: true,
            showPreviewImg: false, //是否预览
            previewList: [], //预览文件列表
            showIndex: 0
        };
    },
    methods: {
        initFileList () {
            if(this.imgList && this.imgList.length){
                this.fileList = this.imgList.map((item,index)=>{
                    return {
                        name: item,
                        url: item,
                        mediaId: this.mediaList[index] || ''
                    }
                })
            }else{
                this.fileList = []
            }
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(index, fileList) {
            this.showPreviewImg = true;
            this.showIndex = index
            if (fileList.length) {
                fileList.map((item, index) => {
                    this.previewList.push(item.url)
                })

            }

        },
        handleExceed(files, fileList) {
            if (fileList.length > 0) {
                if (fileList[0].status == "success") {
                    this.$message.warning(
                        `当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length
                        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
                    );
                }
            }

        },
        beforeRemove(file, index) {
            let that = this;
            return this.$confirm(`确定移除 ${file.name}？`, {
                callback: (action) => {
                    if (action == "confirm") {
                        that.fileList.splice(index, 1);
                        this.$emit("update:imgList", this.fileList.map(item => item.url));
                        this.$emit("update:mediaList", this.fileList.map(item => item.mediaId));
                    }
                },
            });
        },
        async handleChange (file, fileList) {
            if (file.response) {
                if (file.response.code == 0) {
                    this.iswatch = false;
                    this.filesImg[file.name] = file.url || "";
                    let mediaId = await this.getImgWxMedia(file.response.data)
                    this.fileList.push({
                        name: file.name,
                        url: file.response.data,
                        mediaId: mediaId
                    })
                    this.$emit("update:imgList", this.fileList.map(item => item.url));
                    this.$emit("update:mediaList", this.fileList.map(item => item.mediaId));
                } else {
                    this.fileList = []
                    this.filesImg = {}
                }
            }
        },
        handleSuccess(response, file, fileList) {
            let that = this
            if (response.code == 0) {
                this.$emit('handleSuccess')
            } else {
                this.fileList = []
                this.filesImg = {}
                this.$message.error(response.msg)
            }
        },
        // 获取微信media
        getImgWxMedia (url) {
            let apiUrl
            if(this.uploadWxType == 'complaint') { 
                apiUrl = this.$Config.apiUrl.complaintUploadImage // 上传客诉图片至微信
            }else {
                apiUrl = this.$Config.apiUrl.wxUploadFile //上传商户进件图片至微信
            }
            return new Promise((resolve, reject)=>{
                this.$Axios._get({
                    url: apiUrl,
                    params: {
                        url: url,
                        ...this.extraParams
                    }
                }).then((res) => {
                    resolve(res.result.data.media_id)
                }).catch(err=>{
                    resolve('')
                })
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.el-upload__tip {
    white-space: nowrap;
}

.img-content {
    width: 100px;
    height: 100px;
    position: relative;
    margin-right: 14px;

    .deleteImg {
        font-size: 18px;
		position: absolute;
		top: -8px;
		right: -8px;
		color: #606366;
		background: #fff;
		border-radius: 50%
    }
}

.lyimgbox {
    width: 50%;
}
</style>
